import { render, staticRenderFns } from "./HamburgerMenu.vue?vue&type=template&id=56871676&scoped=true"
import script from "./HamburgerMenu.vue?vue&type=script&lang=ts"
export * from "./HamburgerMenu.vue?vue&type=script&lang=ts"
import style0 from "./HamburgerMenu.vue?vue&type=style&index=0&id=56871676&prod&lang=scss&scoped=true"
import style1 from "./HamburgerMenu.vue?vue&type=style&index=1&id=56871676&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56871676",
  null
  
)

export default component.exports